<button #openButton
        mat-icon-button
        class="open-user-activity-panel-button mat-primary-bg mat-elevation-z2"
        *ngIf="auditUserActivityService.currentAuditUserActivityPage"
        (click)="openBar()">
    <mat-icon>work_history</mat-icon>
</button>

<div class="user-activity-panel-overlay" #overlay [fxHide]="barClosed" (click)="onBlurPanel()"></div>

<div #panel
     class="user-activity-panel mat-white-bg mat-elevation-z8"
     infiniteScroll
     [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="50"
     [infiniteScrollContainer]="'.user-activity-panel'"
     [fromRoot]="true"
     [infiniteScrollDisabled]="!hasMoreAuditItems"
     (scrolled)="onScroll()"
>

    <div class="user-activity-panel-content">
        <div class="user-activity-panel-title">
            <h2>
                <ng-container *ngIf="currentUserActivityDetails">
                    <button mat-icon-button
                            class="user-activity-panel-arrow-back"
                            [ngStyle]="{'display': currentUserActivityDetails ? 'contents' : 'none'}"
                            title="Cancel"
                            (click)="onCloseUserActivityDetails()"
                            type="button"
                    >
                        <mat-icon aria-hidden="true">arrow_back</mat-icon>
                    </button>
                    <span>{{AuditUserActivityActionFriendlyTitles[currentUserActivityDetails.actionName]}}</span>
                </ng-container>
                <ng-container *ngIf="!currentUserActivityDetails">Audit user activity</ng-container>

            </h2>
            <button mat-icon-button class="close-button" (click)="closeBar()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="user-activity-panel-inner" fxLayout="column" fxLayoutAlign="start start">
            <div *ngIf="!currentUserActivityDetails"
                 fxLayout="row" fxLayoutAlign="center center"
                 style="width: 100%"
            >
                <mat-form-field class="pt-24">
                    <mat-select multiple
                                (selectionChange)="filterUserActions($event.value)"
                                placeholder="Filter user actions"
                                [formControl]="userActionsFilterCtrl"
                    >
                        <mat-option *ngFor="let userAction of userActionsList" [value]="userAction">
                            {{AuditUserActivityActionFriendlyTitles[userAction] || userAction}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="(auditUserActivityData.length === 0) && !isLoading" class="default-message">
                No data to display
            </div>

            <div *ngIf="isLoading" class="table-container">
                <ngc-ghost-table [rows]="[0,1,2,3,4,5,6,7,8]"></ngc-ghost-table>
            </div>

            <ng-container *ngIf="!currentUserActivityDetails && (auditUserActivityData.length > 0) && !isLoading">
                <ng-container *ngFor="let auditItem of auditUserActivityData; let i = index">

                    <ng-container *ngIf="auditItem?.isFirstListItemInADay">
                        <h5 class="user-activity-date">{{auditItem?.executedAt | date: 'MMM d, y' }}</h5>
                        <mat-divider class="m-0"></mat-divider>
                    </ng-container>

                    <div class="user-activity-info user-activity-info-title"
                         (click)="onOpenUserActivityDetails(auditItem)"
                    >



                        <ng-container *ngIf="auditItem?.view?.userInitiatorLink && !AuditUserActivityPrefixlessActions[auditItem?.actionName]">
                            <a [routerLink]="auditItem?.view?.userInitiatorLink.routerLink"
                               routerLinkActive="active"
                               (click)="onNavigate(auditItem?.view?.userInitiatorLink.page)"
                            >
                                <span>{{auditItem?.view?.userInitiatorLink?.title}}</span>
                            </a>&nbsp;
                        </ng-container>

                        <span class="action">{{AuditUserActivityActionFriendlyNames[auditItem?.actionName]}}</span>

                        <span class="action" *ngIf="auditItem?.view?.objectIdOtherText?.title
                                                    && auditItem?.view?.objectIdOtherText?.value
                                                    && auditItem?.objectId">
                            {{auditItem?.view?.objectIdOtherText?.value}}
                        </span>

                        <span class="action" *ngIf="((auditItem.actionName == AuditUserActivityActions.CREATE_ORGANIZATION)
                                                        || (auditItem.actionName == AuditUserActivityActions.EDIT_ORGANIZATION))
                                                    && (auditUserActivityService.currentAuditUserActivityPage === AuditUserActivityPagesList.ADMINISTRATION_EDIT_ORG)"
                        >
                            organization
                        </span>

                        <ng-container *ngIf="(!!auditItem?.view?.userObjectIdLink?.routerLink || !!auditItem?.view?.appLink?.routerLink)
                                             && !AuditUserActivitySuffixlessActions[auditItem?.actionName]">
                            <a [routerLink]="(auditItem?.view?.userObjectIdLink?.routerLink || auditItem?.view?.appLink?.routerLink)"
                               routerLinkActive="active"
                               (click)="onNavigate(auditItem?.view?.userObjectIdLink?.page || auditItem?.view?.appLink?.page)"
                            >
                                {{auditItem?.view?.userObjectIdLink?.title ? auditItem?.view?.userObjectIdLink?.title : ''}}
                                {{auditItem?.view?.appLink?.title ? auditItem?.view?.appLink?.title : ''}}
                            </a>
                        </ng-container>

                        <ng-container *ngIf="((auditItem.actionName == AuditUserActivityActions.ADD_ORGANIZATION_ADMIN)
                                                || (auditItem.actionName == AuditUserActivityActions.EDIT_ORGANIZATION_ADMINS)
                                                || (auditItem.actionName == AuditUserActivityActions.DELETE_ORGANIZATION_ADMIN))
                                             && auditItem?.view?.userObjectIdLink?.routerLink"
                        >admin account</ng-container>

                        <ng-container *ngIf="((auditItem.actionName == AuditUserActivityActions.ADD_ORGANIZATION_ADMIN)
                                                || (auditItem.actionName == AuditUserActivityActions.EDIT_ORGANIZATION_ADMINS)
                                                || (auditItem.actionName == AuditUserActivityActions.DELETE_ORGANIZATION_ADMIN))
                                             && auditItem?.view?.orgLink?.showInListView"
                        > in </ng-container>

                        <ng-container *ngIf="((auditItem.actionName == AuditUserActivityActions.CREATE_ORGANIZATION)
                                                || (auditItem.actionName == AuditUserActivityActions.EDIT_ORGANIZATION)
                                                || (auditItem.actionName == AuditUserActivityActions.DELETE_ORGANIZATION)
                                                || (auditItem.actionName == AuditUserActivityActions.ADD_ORGANIZATION_ADMIN)
                                                || (auditItem.actionName == AuditUserActivityActions.EDIT_ORGANIZATION_ADMINS)
                                                || (auditItem.actionName == AuditUserActivityActions.DELETE_ORGANIZATION_ADMIN))
                                             || (auditUserActivityService.currentAuditUserActivityPage === AuditUserActivityPagesList.ADMINISTRATION_EDIT_SYS_ADMIN)"
                        >
                            <a *ngIf="auditItem?.view?.orgLink?.showInListView"
                               [routerLink]="auditItem?.view?.orgLink.routerLink"
                               routerLinkActive="active"
                               (click)="onNavigate(currentUserActivityDetails?.view?.orgLink.page)"
                            >
                                <span>{{auditItem?.view?.orgLink.title}}</span>
                            </a>

                            <ng-container *ngIf="(auditUserActivityService.currentAuditUserActivityPage === AuditUserActivityPagesList.ADMINISTRATION_EDIT_SYS_ADMIN)">
                                organization
                            </ng-container>
                        </ng-container>



                        <div class="user-activity-time"
                             [matTooltip]="auditItem?.executedAt | datePlusGMTPipe: 'medium' "
                             [matTooltipShowDelay]="500"
                        >
                            {{auditItem?.executedAt | datePlusGMTPipe: 'hh:mm a, z'}}
                        </div>
                    </div>

                    <mat-divider class="m-0"></mat-divider>
                </ng-container>

                <mat-progress-spinner *ngIf="isLoadingNext"
                                      class="get-next-user-audit-items-spinner"
                                      [color]="'accent'"
                                      [diameter]="50"
                                      [mode]="'indeterminate'"
                >
                </mat-progress-spinner>
            </ng-container>






            <ng-container *ngIf="currentUserActivityDetails">

                <h5 *ngIf="currentUserActivityDetails"
                    class="user-activity-date"
                    [ngClass]="{'audit-details': currentUserActivityDetails}">
                    {{currentUserActivityDetails?.executedAt | datePlusGMTPipe: 'medium' }}
                </h5>

                <div class="user-activity-info" [ngClass]="{'audit-details': currentUserActivityDetails}">

                    <div *ngIf="currentUserActivityDetails?.httpPath" class="details-info-line">
                        <div class="title">HTTP path:</div>
                        <div class="info" [matTooltip]="currentUserActivityDetails?.httpPath" [matTooltipShowDelay]="500">
                            {{currentUserActivityDetails?.httpPath}}
                        </div>
                    </div>

                    <div *ngIf="currentUserActivityDetails?.userEmail
                                && currentUserActivityDetails?.view?.userInitiatorLink?.title"
                         class="details-info-line"
                    >
                        <span class="title">User email:</span>
                        <ng-container *ngTemplateOutlet="auditDetailsInfoContainerTemplate; context:{auditDetailsViewItem: currentUserActivityDetails?.view.userInitiatorLink}"></ng-container>
                    </div>

                    <div *ngIf="currentUserActivityDetails?.objectId
                                && (currentUserActivityDetails?.objectId !== currentUserActivityDetails?.orgGuid)
                                && currentUserActivityDetails?.view?.userObjectIdLink?.title
                                && currentUserActivityDetails?.view?.userObjectIdLink?.routerLink"
                         class="details-info-line"
                    >
                        <span class="title">
                            {{AuditUserActivityActionObjectIdMap[currentUserActivityDetails?.actionName]
                            ? AuditUserActivityActionObjectIdTitleList[AuditUserActivityActionObjectIdMap[currentUserActivityDetails?.actionName]]
                            : 'Object Id'}}:
                        </span>
                        <ng-container *ngTemplateOutlet="auditDetailsInfoContainerTemplate; context:{auditDetailsViewItem: currentUserActivityDetails?.view.userObjectIdLink}"></ng-container>
                    </div>

                    <div *ngIf="currentUserActivityDetails?.view?.objectIdOtherText?.title
                                 && currentUserActivityDetails?.view?.objectIdOtherText?.value"
                         class="details-info-line"
                    >
                        <span class="title">
                            {{currentUserActivityDetails?.view?.objectIdOtherText?.title}}
                        </span>

                        <div class="info"
                             [matTooltip]="currentUserActivityDetails?.view?.objectIdOtherText?.value"
                             [matTooltipShowDelay]="500"
                        >
                            <span>{{currentUserActivityDetails?.view?.objectIdOtherText?.value}}</span>
                        </div>
                    </div>

                    <div *ngIf="currentUserActivityDetails?.view?.appLink?.title && currentUserActivityDetails?.view?.appLink?.routerLink"
                         class="details-info-line"
                    >
                        <span class="title">Application name:</span>
                        <ng-container *ngTemplateOutlet="auditDetailsInfoContainerTemplate; context:{auditDetailsViewItem: currentUserActivityDetails?.view.appLink}"></ng-container>
                    </div>

                    <div *ngIf="currentUserActivityDetails?.view?.orgLink?.routerLink && currentUserActivityDetails?.view?.orgLink?.title" class="details-info-line">
                        <span class="title">Organization:</span>
                        <ng-container *ngTemplateOutlet="auditDetailsInfoContainerTemplate; context:{auditDetailsViewItem: currentUserActivityDetails?.view.orgLink}"></ng-container>
                    </div>

                    <div *ngIf="currentUserActivityDetails?.clientIpAddress" class="details-info-line">
                        <span class="title">Client IP address:</span>
                        <div class="info">{{currentUserActivityDetails?.clientIpAddress}}</div>
                    </div>

                    <div *ngIf="currentUserActivityDetails?.serverIpAddress" class="details-info-line">
                        <span class="title">Server IP address:</span>
                        <div class="info">{{currentUserActivityDetails?.serverIpAddress}}</div>
                    </div>

                    <div *ngIf="currentUserActivityDetails?.parameters" class="details-info-line params">
                        <span class="title">Parameters:</span>
                        <div *ngIf="currentUserActivityDetails?.parameters" class="params-info-line">
                            <p *ngFor="let parameter of currentUserActivityDetails?.parametersList">
                                <span class="params-title">{{parameter.name}}{{parameter.value ? ':' : ''}} </span>
                                <span>{{parameter.value}}</span>
                            </p>
                        </div>
                    </div>

                </div>
            </ng-container>



        </div>
    </div>

</div>

<ng-template #auditDetailsInfoContainerTemplate let-auditDetailsViewItem="auditDetailsViewItem">
    <div class="info"
         [matTooltip]="auditDetailsViewItem?.title"
         [matTooltipShowDelay]="500"
    >
        <a *ngIf="(auditDetailsViewItem?.page != auditUserActivityService.currentAuditUserActivityPage)"
           [routerLink]="auditDetailsViewItem?.routerLink"
           routerLinkActive="active"
           (click)="onNavigate(auditDetailsViewItem?.page)"
        >
            {{auditDetailsViewItem?.title}}
        </a>
        <span *ngIf="(auditDetailsViewItem?.page == auditUserActivityService.currentAuditUserActivityPage)">
            {{auditDetailsViewItem?.title}}
        </span>
    </div>
</ng-template>
